import { AccountBadgePreviewModal } from '../../../../ui/features/badge-preview/components/AccountBadgePreviewModal';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
export function showAccountBadgePreviewModal(accountBadge) {
    showCustomDialog({
        maxWidth: 'xs',
        content: (close, ariaTitleId, ariaContentId) => (React.createElement(AccountBadgePreviewModal, { ariaTitleId: ariaTitleId, ariaContentId: ariaContentId, accountBadge: accountBadge, close: close })),
        onEscapeKeyDown: (close) => close(),
    });
}
